import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link2, Copy, MessageCircle } from "lucide-react";

const LinkRow = ({ id, label, url, msg }) => (
  <div className="rounded-lg border border-border/60 bg-card/60 p-3">
    <p className="eyebrow text-gold">{label}</p>
    <p className="text-xs text-white break-all mt-1" data-testid={`join-link-${id}-url`}>{url}</p>
    <div className="flex gap-2 mt-2">
      <Button size="sm" onClick={() => { navigator.clipboard.writeText(url); toast.success("Link copied"); }} data-testid={`join-link-${id}-copy`}
        className="h-8 bg-gold text-[#0a2e22] hover:bg-gold/90 gap-1.5 text-xs"><Copy className="w-3.5 h-3.5" /> Copy</Button>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${msg} ${url}`)}`} target="_blank" rel="noopener noreferrer" data-testid={`join-link-${id}-wa`}>
        <Button size="sm" variant="outline" className="h-8 border-emerald-400/40 text-emerald-300 gap-1.5 text-xs"><MessageCircle className="w-3.5 h-3.5" /> WhatsApp</Button>
      </a>
    </div>
  </div>
);

export const JoinLinkButton = () => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  useEffect(() => { if (open && !code) { api.get("/my-referral").then((r) => setCode(r.data.referral_code || "")).catch(() => {}); } }, [open, code]);
  const base = window.location.origin;
  const q = code ? `?ref=${code}` : "";
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="nav-join-link-btn"
        className="mt-2 w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold bg-gold text-[#0a2e22] hover:bg-gold/90 transition-colors">
        <Link2 className="w-4 h-4" /> Joining Link
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#05261D] border-gold/20" data-testid="join-link-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-gold flex items-center gap-2"><Link2 className="w-5 h-5" /> Your joining links</DialogTitle>
            <DialogDescription>Everyone who joins through these links is credited to you automatically.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <LinkRow id="customer" label="Umrah customer joining" url={`${base}/portal${q}`} msg="Assalamu Alaikum! Book your Umrah with Bengal Umrah House Travels:" />
            <LinkRow id="member" label="Become a member" url={`${base}/agent${q}`} msg="Join Bengal Umrah House Travels as a member and earn commission:" />
            <LinkRow id="jobs" label="Jobs abroad joining" url={`${base}/jobs${q}`} msg="Overseas jobs with Bengal Umrah House Travels — apply here:" />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
